import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import {JackpotBetWinHighlightContentBox} from "./boxes/jackpot-bet-win-highlight-content/jackpot-bet-win-highlight-content.box";
import {JackpotBetWinHighlightBox} from "./boxes/jackpot-bet-win-highlight/jackpot-bet-win-highlight.box";
import {IJackpotBetWinInfo} from "./interfaces/jackpot-bet-win-info.interface";

interface JackpotBetWinHighlightProps {
    availablePrizes: IJackpotBetWinInfo[];
}

export const JackpotBetWinHighlight: React.FC<JackpotBetWinHighlightProps> = observer((props) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [shakeTimeExpired, setShakeTimeExpired] = useState(true);

    useEffect(() => {
        if (props.availablePrizes.length === 0) return;

        let timeoutId: ReturnType<typeof setTimeout>;

        const runCycle = () => {
            setShakeTimeExpired(false);

            timeoutId = setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % props.availablePrizes.length);
                setShakeTimeExpired(true);
                timeoutId = setTimeout(runCycle, 2250); // 2500 - 250 = 2250
            }, 250);
        };

        runCycle();

        return () => {
            clearTimeout(timeoutId);
        };
    }, [props.availablePrizes.length]);

    if (props.availablePrizes.length === 0) return null;

    return (
        <JackpotBetWinHighlightBox>
            <JackpotBetWinHighlightContentBox
                className={shakeTimeExpired ? "fade-in" : "fade-out"}
            >
                {props.availablePrizes[currentIndex].render()}
            </JackpotBetWinHighlightContentBox>
        </JackpotBetWinHighlightBox>
    );
}
);
